import React from 'react';
import {
	MdChevronRight,
	MdChevronLeft,
	MdRadioButtonChecked,
	MdRadioButtonUnchecked,
	MdCheck,
	MdPhone,
	MdEmail,
	MdLanguage,
	MdDirectionsCar,
	MdToday,
	MdAccessTime,
	MdLocationOn,
	MdAccountBox,
	MdMessage
} from 'react-icons/md';

const components = {
	MdChevronRight,
	MdChevronLeft,
	MdRadioButtonChecked,
	MdRadioButtonUnchecked,
	MdCheck,
	MdPhone,
	MdEmail,
	MdLanguage,
	MdDirectionsCar,
	MdToday,
	MdAccessTime,
	MdLocationOn,
	MdAccountBox,
	MdMessage
};

function Icon ({ name, align }) {
	if (!components[name]) { return null; }

	const ReactIcon = components[name];
	const style = {
		verticalAlign: align || 'bottom'
	};

	return (
		<ReactIcon className='react-icon' size={18} style={style} />
	);
}

export default Icon;
